import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://mvbitrngpjcjamwozcci.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im12Yml0cm5ncGpjamFtd296Y2NpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODI2ODAzNTEsImV4cCI6MjA5ODI1NjM1MX0.uMUdCVB5dtDrMcyKnES4cdvl9I9UqYftOMLEwdX6ToY'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)